import React from 'react';
import { Spinner } from 'react-bootstrap';
import { Form, FormGroup, ValidationMessage } from '~/components/Form';

const maxLength = 500;

export interface AddNoteProps {
    noteOpen: boolean;
    toggleNote: () => void;
    addNote: (noteStr: string) => void;
}
export function AddNote({ noteOpen, toggleNote, addNote }: AddNoteProps) {
    const [newNote, setNewNote] = React.useState('');
    const [loading, setLoading] = React.useState(false);
    React.useEffect(() => {
        setNewNote('');
    }, [noteOpen]);

    async function save() {
        setLoading(true);
        await addNote(newNote);
        setLoading(false);
    }
    const noteLength = newNote ? newNote.length : 0;

    return (
        <>
            <div className="patient-modal-notes">
                <div className="row add-note mb-2">
                    <div className="col-sm-12 h4">
                        <button
                            type="button"
                            className={`btn pull-right ${noteOpen ? 'btn-danger' : 'btn-success'}`}
                            onClick={toggleNote}
                        >
                            <i
                                className={`fa-solid ${
                                    noteOpen ? 'fa-minus-circle' : 'fa-plus-circle'
                                }`}
                            />{' '}
                            {noteOpen ? 'Close Note' : 'Add Note'}
                        </button>
                    </div>
                </div>
                {noteOpen && (
                    <div className="row add-note mb-2">
                        <div className="col-sm-12">
                            <Form onSubmit={save} values={{ newNote }}>
                                <FormGroup htmlFor="newNote" className="mb-3">
                                    <textarea
                                        id="newNote"
                                        className="form-control"
                                        rows={4}
                                        maxLength={500}
                                        required
                                        aria-label="New Note"
                                        onChange={(e) => setNewNote(e.target.value)}
                                        value={newNote}
                                    />
                                    <ValidationMessage type="required">
                                        Note is required.
                                    </ValidationMessage>
                                </FormGroup>
                                <div>
                                    <button
                                        className="btn btn-primary pull-right ms-2"
                                        type="submit"
                                        disabled={loading}
                                    >
                                        {loading && (
                                            <Spinner
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                className="me-2"
                                            />
                                        )}
                                        Save
                                    </button>
                                    <span className="pull-right mt-2">
                                        {noteLength} / {maxLength}
                                    </span>
                                </div>
                            </Form>
                        </div>
                    </div>
                )}
            </div>
            <hr />
        </>
    );
}
